import React from 'react';
import { HistoryProvider } from '@tanium/react-history-context';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import { ThemeProvider as TaniumThemeProvider } from '@tanium/react-theme-context';
import { bluestar } from '@tanium/theme-data';
import { History } from 'history';

interface Props {
  history: History;
  permissions?: string[];
}

export const AppWrapper: React.FC<Props> = ({ history, children }) => {
  return (
    <EmotionThemeProvider theme={bluestar}>
      <TaniumThemeProvider theme={bluestar}>
        <HashRouter>
          <HistoryProvider history={history}>{children}</HistoryProvider>
        </HashRouter>
      </TaniumThemeProvider>
    </EmotionThemeProvider>
  );
};
